import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { ChoiceApi } from "@/Modules/Models/Api/Choice";
import type { Choice } from "@/Modules/Models/Domain/Choice";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";
import camelize from "@/Utils/Camelize";

const ChoicesTransformer: TransformerExtended<Choice[], ChoiceApi[]> = {
  ...DefaultTransformerGenerator<Choice[], ChoiceApi[]>(),

  toDomain(input) {
    return input.map((element) => {
      return camelize<ChoiceApi, Choice>(
        element,
        ["value", "i18n", "text", "extra"],
        [undefined, "i18n", "label", undefined]
      ) as Choice;
    });
  },
};

export type ChoicesTransformerType = TransformerExtended<Choice[], ChoiceApi[]>;

export default ChoicesTransformer;
